import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Space,
  Typography,
  message,
} from "antd";
import { ComponentType, useState } from "react";
import "antd/dist/reset.css";
import axios from "axios";

// DEV
// const API_DOMAIN = "https://dev.fnet.com.vn/login/info/";
// const API_ACTION = "register";

//REAL
const API_DOMAIN = "https://ffood.fusoft.vn";
const API_ACTION = "/api/register";

interface Props {}

export const Register: ComponentType<Props> = ({}) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields();
  };

  const handleRegister = async (e: any) => {
    setLoading(true);
    const params = {
      email: form.getFieldValue("email").trim(),
      host: form.getFieldValue("host").trim(),
      password: form.getFieldValue("password").trim(),
    };

    axios
      .post(API_DOMAIN + API_ACTION, params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer 123",
        },
      })
      .then((response) => {
        //console.log(response);
        //console.log(response.data);

        const dataObject = JSON.stringify(response.data.data);
        //const dataObject = JSON.stringify(response.data);
        //console.log(dataObject);

        const result = response.data.result;
        const errMsg = response.data.errMsg;

        if (parseInt(result) === 1) {
          form.resetFields();
          setLoading(false);
          message.success("Xử lý thành công.");
          try {
            window.registerObj(dataObject);
          } catch (error) {
            //console.log(error);
            return;
          }
        } else {
          setLoading(true);
          message.error(errMsg);
          return;
        }
      })
      .catch((error) => {
        // error is handled in catch block
        if (error.response) {
          if (error.response.status === 400 || null) {
            //message.error("Đăng ký thất bại");
            console.log("error", error.message);
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Error on setting up the request
          console.log("error", error.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
    //
  };

  return (
    <>
      <Form
        onFinish={handleRegister}
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        layout="vertical"
      >
        <br />
        <Row>
          <Col span={8}></Col>
          <Col span={8}>
            {/* ĐĂNG KÝ THÔNG TIN */}
            <Typography.Title
              style={{
                fontFamily: "arial",
                fontSize: 25,
                textAlign: "center",
                paddingBottom: 5,
              }}
            >
              Đăng nhập
              <p style={{ fontSize: 13, fontWeight: "normal", paddingTop: 10 }}>
                Vui lòng đăng nhập bằng tài khoản đã đăng ký FFood để bật tính
                năng gọi món tại máy trạm
              </p>
            </Typography.Title>
          </Col>
          <Col span={8}></Col>
        </Row>

        <Row>
          <Col span={8}></Col>
          <Col span={12}>
            <Form.Item
              style={{ fontWeight: "bold" }}
              label="FFood ID:"
              name="host"
              rules={[{ required: true, message: "Vui lòng nhập FFood ID." }]}
              hasFeedback
            >
              <Input placeholder="VD: ff079043" />
            </Form.Item>
          </Col>
          <Col span={4}></Col>
        </Row>
        <Row>
          <Col span={8}></Col>
          <Col span={12}>
            <Form.Item
              style={{ fontWeight: "bold" }}
              label="Email:"
              name="email"
              rules={[
                { required: true, message: "Vui lòng nhập email." },
                { type: "email", message: "Email không đúng định dạng." },
                // {
                //   whitespace: true,
                //   message: "Email không được có khoảng trống.",
                // },
              ]}
              hasFeedback
            >
              <Input placeholder="Nhập email đã đăng ký" allowClear={false} />
            </Form.Item>
          </Col>
          <Col span={4}></Col>
        </Row>
        <Row>
          <Col span={8}></Col>
          <Col span={12}>
            <Form.Item
              style={{ fontWeight: "bold" }}
              label="Mật khẩu:"
              name="password"
              rules={[
                { required: true, message: "Vui lòng nhập mật khẩu." },
                {
                  whitespace: true,
                  message: "Mật khẩu không được khoảng trống.",
                },
                { min: 5, message: "Mật khẩu ít nhất 5 ký tự." },
              ]}
              hasFeedback
            >
              <Input.Password placeholder="Nhập mật khẩu" />
            </Form.Item>
          </Col>
          <Col span={4}></Col>
        </Row>

        <Row>
          <Col span={8}></Col>
          <Col span={8}>
            <Button block type="primary" htmlType="submit" loading={loading}>
              Đăng nhập
            </Button>
          </Col>
          <Col span={8}></Col>
        </Row>
        <Row>
          <Col span={8}></Col>
          <Col span={8}>
            <Divider plain>
              Chưa có tài khoản? Đăng ký{" "}
              <a href="https://portal.ffood.com.vn/register" target="_self">
                tại đây
              </a>
            </Divider>
          </Col>
          <Col span={8}></Col>
        </Row>
      </Form>
    </>
  );
};
